import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const InfoRow = styled.span`
	display: inline-flex;
`;

export const InfoRowFlex = styled.span`
	display: inline-flex;
	align-items: center;
`;

export const Anchor = css`
	color: #337ab7;
`;
